import { createContext, useContext, useEffect, useState } from "react";
import { Instagram, Youtube } from "lucide-react";
import { getSettings } from "@/lib/api";

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" {...p}><path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.7 5.7 0 1 0 4.9 5.7V9a7.3 7.3 0 0 0 4.3 1.4V7.3a4.3 4.3 0 0 1-3.2-1.5z" /></svg>
);
const Pinterest = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" {...p}><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.8 3.4-.2 1 .5 1.9 1.5 1.9 1.9 0 3.3-2 3.3-4.8 0-2.5-1.8-4.3-4.4-4.3-3 0-4.8 2.3-4.8 4.6 0 .9.4 1.9.8 2.4.1.1.1.2.1.3l-.3 1.2c0 .2-.2.3-.4.2-1.4-.6-2.2-2.6-2.2-4.2 0-3.4 2.5-6.6 7.2-6.6 3.8 0 6.7 2.7 6.7 6.3 0 3.7-2.4 6.8-5.6 6.8-1.1 0-2.2-.6-2.5-1.3l-.7 2.6c-.2 1-.9 2.2-1.4 2.9A10 10 0 1 0 12 2z" /></svg>
);

export const SOCIAL = [["instagram", "Instagram", Instagram], ["tiktok", "TikTok", TikTok], ["youtube", "YouTube", Youtube], ["pinterest", "Pinterest", Pinterest]];
const EMPTY = { instagram: "", tiktok: "", youtube: "", pinterest: "", contact_email: "" };
const Ctx = createContext(EMPTY);

export const SettingsProvider = ({ children }) => {
  const [s, setS] = useState(EMPTY);
  useEffect(() => { getSettings().then(setS).catch(() => {}); }, []);
  return <Ctx.Provider value={s}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
export const sameAs = (s) => SOCIAL.map(([k]) => s[k]).filter(Boolean);

export const SocialLinks = ({ className = "", linkClass = "", prefix = "social" }) => {
  const s = useSettings();
  const items = SOCIAL.filter(([k]) => s[k]);
  if (!items.length) return null;
  return (
    <ul className={`flex gap-4 ${className}`} data-testid={`${prefix}-links`}>
      {items.map(([k, name, Icon]) => (
        <li key={k}><a href={s[k]} target="_blank" rel="noreferrer me" aria-label={`the suspects on ${name}`} className={linkClass} data-testid={`${prefix}-${k}`}><Icon size={18} strokeWidth={1.5} /></a></li>
      ))}
    </ul>
  );
};
